import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/src/components/designSystem/SkeletonLoader'

import {
  BadgeWrapper,
  BannerWrapper,
  CardWrapper,
  HeroWrapper,
  InlineWrapper,
  PanelWrapper,
  SummaryWrapper
} from './styles'
import {TrustPilotWidgetVariant} from './TrustpilotWidget'

interface Props {
  variant?: TrustPilotWidgetVariant
}
export const TrustpilotWidgetLoading = ({variant}: Props) => {
  switch (variant) {
    case 'banner':
      return (
        <BannerWrapper className="--loading">
          <SkeletonLoader marginTop={0} width={62} />
          <SkeletonLoader marginTop={0} width={108} />
          <SkeletonLoader marginTop={0} width={250} />
        </BannerWrapper>
      )

    case 'inline':
      return (
        <InlineWrapper className="--loading">
          <SkeletonLoader marginTop={0} width={108} />
          <SkeletonLoader marginTop={0} width={210} />
        </InlineWrapper>
      )

    case 'card':
      return (
        <CardWrapper as="div">
          <Box display="flex" flexDirection="column" gap="s600">
            <div>
              <SkeletonLoader width={75} />
              <SkeletonLoader width={100} />
            </div>
            <div>
              <SkeletonLoader width={75} />
              <SkeletonLoader width={75} />
            </div>
          </Box>
        </CardWrapper>
      )

    case 'badge':
      return (
        <BadgeWrapper as="div">
          <SkeletonLoader
            className="--stars-skeleton"
            marginTop={0}
            width={130}
          />
          <SkeletonLoader marginTop={0} width={80} />
        </BadgeWrapper>
      )

    case 'panel':
      return (
        <PanelWrapper className="--loading">
          <SkeletonLoader marginTop={0} width={196} />
          <div className="--row">
            <SkeletonLoader marginTop={0} width={60} />
            <SkeletonLoader marginTop={0} width={100} />
            <SkeletonLoader marginTop={0} width={75} />
          </div>
        </PanelWrapper>
      )
    case 'hero':
      return (
        <HeroWrapper className="--loading">
          <div className="--score-block">
            <SkeletonLoader width={125} />
            <SkeletonLoader width={84} />
          </div>
          <div className="--reviews-block">
            <SkeletonLoader marginTop={0} width={108} />
          </div>
        </HeroWrapper>
      )

    case 'summary':
    default:
      return (
        <SummaryWrapper as="div">
          <Box display="flex" alignItems="flex-start" gap="s400">
            <Box width="42px" height="42px">
              <SkeletonLoader height="100%" />
            </Box>
            <div>
              <SkeletonLoader width={68} />
              <SkeletonLoader width={105} />
            </div>
          </Box>
        </SummaryWrapper>
      )
  }
}
